import { render, staticRenderFns } from "./TableVacations.vue?vue&type=template&id=3a5bea4c"
import script from "./TableVacations.vue?vue&type=script&lang=js"
export * from "./TableVacations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports